import { PrimaryButton } from "@/features/ui/buttons/primary";
import { api_rendicion } from "@/libs/axios/api";
import { colors } from "@/styles/colors";
import { Data } from "@/types/generics";
import { saveSessionCookie } from "@/utils";
import { saveLocalUser } from "@/utils/getLocalUser";
import Link from "next/link";
import { useRouter } from "next/router";
import { ChangeEvent, FormEvent, useState } from "react";
import styled from "styled-components";

export function LoginForm() {
  const router = useRouter();

  const [inputs, setInputs] = useState({ email: "", password: "" });
  const [state, setState] = useState<Data>({
    isLoading: false,
    error: null,
    data: null,
  });

  const onChange = ({
    target: { name, value },
  }: ChangeEvent<HTMLInputElement>) => {
    setInputs((old) => ({ ...old, [name]: value }));
  };

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();

    try {
      setState({ error: null, isLoading: true, data: null });

      const { data } = await api_rendicion.post(`/auth/login`, inputs);
      if (!data)
        throw {
          message: "No se pudo generar el token",
          code: "token-not-found",
        };

      console.log(data.user);

      // Se genera la cookie de sesion y se guardan los datos del usuario en el local storage
      saveSessionCookie(data.token, data.expires);
      saveLocalUser({ ...data.user, created_at: new Date().getTime() });

      setState({ error: null, isLoading: false, data });
      router.push("/");
    } catch (e: any) {
      if (e.response?.data)
        setState({ data: null, isLoading: false, error: e.response.data });
      else
        setState({
          data: null,
          isLoading: false,
          error: { code: e.code, message: e.message },
        });
    }
  };

  return (
    <Container onSubmit={onSubmit}>
      <div className="group">
        <label htmlFor="email">Email</label>
        <input
          name="email"
          type="email"
          onChange={onChange}
          value={inputs.email}
          placeholder="usuario@ejemplo.com"
        />
      </div>

      <div className="group">
        <label htmlFor="password">Password</label>
        <input
          name="password"
          type="password"
          onChange={onChange}
          value={inputs.password}
          placeholder="contraseña"
        />
      </div>

      <div className="buttons">
        <Link href="/recover" className="recover">
          Recuperar contraseña
        </Link>
        <PrimaryButton isLoading={state.isLoading} type="submit">
          Iniciar sesion
        </PrimaryButton>
      </div>
      {state.error ? <p>{state.error.message}</p> : null}
    </Container>
  );
}

const Container = styled.form`
  display: grid;
  gap: 1rem;
  max-width: 300px;

  .group {
    display: flex;
    flex-flow: column;
    width: 100%;

    label {
      width: 100%;
      font-weight: 500;
      font-size: 0.8rem;
      color: #555;
      margin: 0 0 0.25rem 0;
    }

    input {
      width: 100%;
      border: 1px solid #aaa;
      border-radius: 5px;
      padding: 0.5rem 0.75rem;
    }
  }

  .group:focus-within {
    label {
      color: #${colors.primary._400};
    }
    input {
      outline: 2px solid #${colors.primary._400};
    }
  }

  .buttons {
    display: flex;
    flex-flow: column;
    margin: 1rem 0 0 0;
    gap: 0.5rem;
  }

  .recover {
    margin: 0 0 0.5rem 0;
    color: #aaa;
    font-size: 0.9rem;
    text-decoration: underline;
  }
`;
